import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { environment } from "../../environments/environment";
import { SessionStorageService } from '../_services';

@Injectable()
export class PlanGuard implements CanActivate {
  constructor(private router: Router, private sessionState: SessionStorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    switch (+this.sessionState.getProductSubClassId()) {
      case environment.subClassTotalPlan:
        return true;
      case environment.subClassSystemsPlan:
        return state.url !== '/dash/appliances/service' && state.url !== '/dash/appliances/diy';
      case environment.subClassAppliancePlan:
        return state.url !== '/dash/systems/referral' && state.url !== '/dash/systems/diy';
      default:
        break;
    }
    this.router.navigate(['/404']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/_guards/plan.guard.ts